module.exports = __webpack_public_path__ + "img/icon-mas.7e21e37b.svg";